// extracted by mini-css-extract-plugin
export default {"BulkActionsMenu":"_BulkActionsMenu--oCf8d","Content":"_Content--a4ol6","SelectedCount":"_SelectedCount--UvBhy"};